import React from 'react';

import { BusinessUIAccoladeProvider } from '@bcp-business-ui/theme-accolade';
import { CFPGlobalProvider } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { AppRoot, Debug, ErrorBoundary, LoggerOverlay } from '@bcp-channels-sharedcomponents-reactjs/core';
import { FormatHelper, LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { Company, Language, Platform } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { Box, GlobalStyle, Loader, ThemeProvider } from '@bcp-nextgen-dx-component-factory/design-system';
import { Accolade } from '@bcp-nextgen-dx-component-factory/theme-accolade';
import { Foundation } from '@bcp-nextgen-dx-component-factory/theme-foundation';
import { UnexpectedError } from '@components';
import { InfoConfig, LoggerConfig } from '@configs';
import { AppModals } from '@modals';
import { BaseSessionInfo, BaseSessionInfoLanguage } from '@types';

import { GlobalLoader } from './components/globalLoader';
import { ConfigureApp, globalLoaderKey } from './configureApp';

interface StartupAppProps {
	sessionInfo: BaseSessionInfo;
}

export const StartupApp: React.FC<StartupAppProps> = ({ sessionInfo }) => {
	const isAb = sessionInfo.company?.toLowerCase() === 'ab';

	LoggerHelper.log('StartupApp', 'SessionInfo >>', sessionInfo);

	return (
		<>
			{/* TODO: check if AppRoot is needed, because it's replaced by CFPGlobalProvider */}
			<AppRoot
				globalData={{
					company: isAb ? Company.ab : Company.bcp,
					language: FormatHelper.formatLanguageCode(sessionInfo.language),
					platform: Platform.mobile,
				}}
				appId="publicConsumerLoans"
			>
				{/* <ThemeProvider
				theme={isAb ? Foundation : Accolade}
				locale={{
					default: sessionInfo.language.toLocaleLowerCase() === 'pt' ? 'pt-PT' : 'en-US',
					// overrides: { currency: sessionInfo.language.toLocaleLowerCase() === 'pt' ? 'pt-PT' : 'en-US' },
				}}
			> */}
				<CFPGlobalProvider
					globalData={{
						company: isAb ? 'ab' : 'bcp',
						language: sessionInfo.language === BaseSessionInfoLanguage.EN ? 'en' : 'pt',
					}}
					theme={isAb ? Foundation : Accolade}
					locale={{
						default: 'pt-PT',
						// overrides: { currency: sessionInfo.language.toLocaleLowerCase() === 'pt' ? 'pt-PT' : 'en-US' },
					}}
					appId="publicConsumerLoans"
					oAuth={{
						token: sessionInfo.api.tokenOAuth,
					}}
					options={{ allowPullToRefresh: true }}
				>
					<BusinessUIAccoladeProvider>
						{LoggerConfig.debug && (
							<>
								<Debug version={InfoConfig.buildNumber} />
								<LoggerOverlay />
							</>
						)}
						{/* Not needs <GlobalStyle /> because it's loaded from <CFPGlobalProvider> */}
						{/* <GlobalStyle /> */}
						<GlobalLoader />
						<AppModals />
						<ErrorBoundary
							containerErrorMessage={(error: any): React.ReactNode => <UnexpectedError error={error} />}
						>
							<ConfigureApp sessionInfo={sessionInfo} />
						</ErrorBoundary>
					</BusinessUIAccoladeProvider>
				</CFPGlobalProvider>
				{/* </ThemeProvider> */}
			</AppRoot>
		</>
	);
};
